module.exports = __webpack_public_path__ + "img/rowed.c4389b8b.png";